export default "__VITE_ASSET__DxrsQmqs__"